// @ts-nocheck
import React, { useContext } from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import TypographyPro from 'themes/TypographyPro'
import IconComponent from 'themes/IconComponent'
import Link from 'next/link'
import FeatureFlag from 'components/common/FeatureFlag'
import { FeatureFlagEnum } from 'types/constants.types'
import { getLocaleStr, codeToLocale, getTranslatedTextByKey, normalizeFileNameStr } from 'utils/utils'
import { StoreContext } from 'contexts/StoreContext'

const RightArrowIcon = (props) => <IconComponent asset="/icons/rightArrow.svg" {...props} />

const StyledContainerLink = styled.div`
	padding: 20px 20px 0px 20px;
`

const StyledSubContainerLink = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`

const StyledLink = styled(TypographyPro)`
	color: var(--primary);
`

const StyledRightArrowIcon = styled(RightArrowIcon)`
	width: 12px;
	height: 12px;

	path {
		stroke-width: 1.95px;
		stroke: var(--primary);
	}
`

const MenuGridHeader = inject(
	'Infra',
	'User'
)(
	observer(({ Infra, User }) => {
		const { store } = useContext(StoreContext)
		const locale = codeToLocale[User.preferredLanguage]

		// By default we use the unlocalized page
		let pageLink = getLocaleStr(Infra.appParams.features.menuGridHeader?.pages?.unlocalized, locale)

		// If store metadata exists, it means we are on a localized menu
		// so we use the localized page and add the store id at the end of the URL
		if (store.metaData) {
			const storeId = normalizeFileNameStr(getLocaleStr(store.metaData.name, locale))
			pageLink = `${getLocaleStr(Infra.appParams.features.menuGridHeader?.pages?.localized, locale)}/${storeId}`
		}

		return (
			<FeatureFlag flag={FeatureFlagEnum.MENU_GRID_HEADER}>
				<StyledContainerLink id="menu-grid-header">
					<Link href={pageLink}>
						<StyledSubContainerLink>
							<StyledLink variant="BodySmallClickable" data-testid="impressum-link">
								{getTranslatedTextByKey(Infra.appParams.features.menuGridHeader?.title?.key, 'Menu Grid Header')}
							</StyledLink>
							<StyledRightArrowIcon />
						</StyledSubContainerLink>
					</Link>
				</StyledContainerLink>
			</FeatureFlag>
		)
	})
)

export default MenuGridHeader
